
<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="timer" fullScreen="false">
</ngx-spinner>